import { getAuthorizationHeaders } from './shared/helpers/authHelpers';
import axios, { AxiosHeaders } from 'axios';

axios.interceptors.request.use(config => {
	const isAppIdSkipped = Boolean(config?.headers?.skipAppId);
	const authHeaders = getAuthorizationHeaders(isAppIdSkipped);

	if (!config.headers) {
		config.headers = new AxiosHeaders();
	} else if (!(config.headers instanceof AxiosHeaders)) {
		config.headers = new AxiosHeaders(config.headers);
	}

	Object.entries(authHeaders).forEach(([key, value]) => {
		if (value !== undefined) {
			config.headers.set(key, value);
		}
	});

	return config;
});

axios.interceptors.response.use(undefined, error => {
	const statusCode = error.response?.status;

	if (statusCode === 401) {
		sessionStorage.clear();
		window.dispatchEvent(new Event('jwt'));
	}
	return Promise.reject(error);
});
